import { useTranslation } from 'react-i18next';
import { Modal } from '@buy-viasat/react/src/components/Modal';
import { Txt, Surface, useBreakpoints } from '@vst/beam';
import { LocationOn } from '@vst/beam-icons/icons';

import styles from './billingAddressNotVerifiedModal.module.scss';

type BillingAddressNotVerifiedModalProps = {
  primaryAction: () => void;
  secondaryAction: () => void;
  suggestedAddressText: string;
};

export const BillingAddressNotVerifiedModal = ({
  primaryAction,
  secondaryAction,
  suggestedAddressText,
}: BillingAddressNotVerifiedModalProps) => {
  const { viewport } = useBreakpoints();
  const { t } = useTranslation(['personalInformation']);

  return (
    <Modal
      headerIcon={LocationOn}
      colorIcon={'teal_600'}
      headerTitle={t('personalInformation.common.AddressNotVerifiedModal.titleText')}
      primaryLabelText={t('personalInformation.common.AddressNotVerifiedModal.confirmButtonText')}
      secondaryLabelText={t('personalInformation.common.AddressNotVerifiedModal.closeButtonText')}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showSecondaryButtonAsLink={true}
      hideCloseButton={!viewport.smallerOrWithin.sm}
      data-testid="AddressNotVerifiedModal"
    >
      <>
        <Txt variant={'bodySmallRegular'} data-testid="AddressNotVerifiedModalBodyText">
          {t('personalInformation.common.AddressNotVerifiedModal.bodyText')}
        </Txt>
        <Surface
          variant="secondary"
          radius={'8px'}
          className={styles['suggestedAddress']}
          data-testid="AddressNotVerifiedModalSuggestedAddressContainer"
        >
          <Txt variant={'bodySmallBold'} data-testid="AddressNotVerifiedModalSuggestedAddressText">
            {suggestedAddressText}
          </Txt>
        </Surface>
      </>
    </Modal>
  );
};
